// Module
var code = " <p translate=\"RAFFLE_ITEM_LABEL\" class=\"item-amount-label\"></p> ";
// Exports
export default code;